import React from "react";
import Box from "@mui/material/Box";
import logo from "../../assets/logo.png";
import logo_dev from "../../assets/logo-dev.png";
import logo_uat from "../../assets/logo-uat.png";
import logo_local from "../../assets/logo-local.png";

const AppLogo: React.FC = () => {
  const getLogoImage = () => {
    const env = process.env?.REACT_APP_ENVIRONMENT;
    if (env === "LOCAL" || env === "DEV" || env === "UAT") {
      const source = env === "UAT" ? logo_uat : env === "DEV" ? logo_dev : logo_local;
      return (
        <img
          style={{
            height: 45,
            marginRight: 10,
            marginLeft: 10,
          }}
          src={source}
          alt="kiwi-rail-logo"
        />
      );
    } else {
      return (
        <img
          style={{
            height: 50,
          }}
          src={logo}
          alt="kiwi-rail-logo"
        />
      );
    }
  };
  return (
    <Box
      sx={{
        bgcolor: "transparent",
        fontSize: 24,
        height: 20,
        minWidth: 120,
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
      }}
    >
      <Box
        sx={{
          paddingTop: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        {getLogoImage()}
        <h2>Shield</h2>
      </Box>
    </Box>
  );
};

export default React.memo(AppLogo);
